export const adminKeys = {
  INTERNAL_CUSTOMER_CONTEXT_DOCUMENT:
    'ADMIN_INTERNAL_CUSTOMER_CONTEXT_DOCUMENT',
};
